import { useSearchParams } from "react-router-dom";
import { PageHeader } from "@/components/page";
import { useEffect, useMemo } from "react";
import { SetupOrganizationPage } from "@/components/page/SetupOrganizationPage";

export const CreateOrganizationPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const stepId = useMemo(() => searchParams.get("stepId"), [searchParams]);
  useEffect(() => {
    if (!stepId) {
      setSearchParams({ stepId: "1" });
    }
  });

  if (!stepId) return <div>Loading...</div>;

  return (
    <div className="flex flex-col flex-grow">
      <PageHeader title={`Setup: Step ${stepId}`}> </PageHeader>
      <SetupOrganizationPage stepId={stepId} />
    </div>
  );
};
